import globalStore from 'store'

/**
 * Gets the register ID from the global store.
 * This function should be used in service classes that need access to the register ID.
 *
 * @returns The register ID from the global store
 * @throws Error if register ID is not available
 */
export const getRegisterIdFromStore = (): string => {
  try {
    const state = globalStore.getState()
    if (!state || !state.register) {
      throw new Error('Register ID is required but not available')
    }
    return state.register.id
  } catch {
    throw new Error('Register ID is required but not available')
  }
}
